import { VDiv } from "./Div";

// This can be used solo via errorElement in the react router
export default function GeneralErrorScreen() {
  return (
    <VDiv
      data-component="GeneralErrorScreen"
      className={`
        h-full gap-4
        items-center mt-20`}
    >
      <img src="/vayda-logo.svg" alt={"Vayda logo"} className="h-10" />
      <span className="text-body text-xl font-bold mt-8">
        Sorry, something went wrong. Please refresh.
      </span>
    </VDiv>
  );
}
